/*
 * Copyright (c) 2020 CalAmp Corp.  All Rights Reserved
 */
import React, {MouseEvent} from 'react';
import {translate} from '@ion/core/src/locale/locale';
import {PrimaryButton} from '../buttons/PrimaryButton';
import {ButtonSpinner} from '../loading/ButtonSpinner';

export interface ChangePasswordButtonProps {
  disabled: boolean;
  onSave: (event: MouseEvent<HTMLButtonElement>) => void;
  label?: string;
  loader: boolean;
};

/**
 *
 * Button to diaply in change password component during first time login.
 * This Component will accept an optional label prop as default Done.
 *
 * ```typescript
 *
 * import {ChangePasswordButton} from '@ion/dls/src/components/buttons/';
 *
 * <ChangePasswordButton disabled={disableUpdate}
 *            onSave={onSave}
 *            loader={isLoading}
 *            label={label} />
 *
 * ```
 *
 * @param   {boolean} disabled Disable the button during password validation or invalid
 * @param   {Function} onSave Method to perform action on updating user new password
 * @param   {boolean} loader To have a spinner in button during API call processing
 * @param   {string} label Label to be displayed in button
 *
 */
export const ChangePasswordButton = ({
  disabled,
  onSave,
  loader,
  label = translate('common:editors.shared.done')
}: ChangePasswordButtonProps) => (
  <PrimaryButton disabled={disabled}
    onClick={onSave}
    type='submit'
    fullWidth>
    {loader ? <ButtonSpinner /> : label}
  </PrimaryButton>
);
